export default __webpack_public_path__ + "static/media/03.b597b1a7.jpg";